import script from "./CreateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__